import * as React from "react";
const SvgSignalCellularAlt2BarOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M5 14h3v6H5v-6zm6-5h3v11h-3V9z" />
  </svg>
);
export default SvgSignalCellularAlt2BarOutlined;
